export default {
  not_set_up: {
    title: 'Les réservations ne sont pas encore configurées pour cet établissement',
    description:
      "Un établissement reçoit des réservations une fois lié à sa fiche Google et doté d'un propriétaire. Si le restaurant n'a pas encore de propriétaire, ajoutez-en un sous Équipe. En attendant, il n'y a pas d'horaires de réservation à modifier ici, et les changements d'horaires de l'Online Shop ne sont pas copiés vers Réservations.",
  },
  company_not_loaded: {
    title: "Les paramètres de réservation n'ont pas pu être chargés",
    description:
      "Les paramètres de réservation de cet établissement n'ont pas pu être chargés ; ses horaires d'ouverture pour les réservations ne peuvent donc pas être modifiés pour le moment. Veuillez réessayer.",
    retry: 'Réessayer',
  },
};
